import moment from 'moment';

import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  context() {
    const createdDate = moment(this.model.get('created_at') || '').utc();
    return {
      date: createdDate.isValid() ? createdDate.format('YYYY-MM-DD') : '',
      time: createdDate.isValid() ? createdDate.format('HH:mm') : '',
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/list/item/headings/date_and_time/index.js